import { h } from 'preact'
import { BulkAction } from '../index'
import { performBulkActionForTopics } from './utils'
import ButtonControl from '../../button-control'
import Icon from '../../assets'

export const trashTopic = () => ({
  Component: ({ performBulkAction } : { performBulkAction: (bulkAction: BulkAction) => void}) =>
    <ButtonControl
      title={<div><Icon icon='trash' width={16} height={16} />Trash</div>}
      size='medium'
      newStyle
      variant='warning'
      class='qa-trash-topic'
      onClick={() => performBulkAction({
        onClick: (topics: any) => performBulkActionForTopics(topics, 'trash'),
        successMessage: 'Topic(s) trashed'
      })}
    />
})
